angular.module('signalview.chartTemplates').run([
    'chartTemplates',
    'Chart',
    function (chartTemplates, Chart) {
        chartTemplates.register('default', function (filters, perMetricFilters) {
            // Default chart template that supports both global and per-metric filters
            //
            // Parameters:
            // - filters: Object containing sf_metric(s) and global filters applied to all metrics
            // - perMetricFilters: Object mapping metric index to filter object (e.g., {0: {host: 'server-1'}})
            //
            // The metric index corresponds to the order of sf_metric parameters in the URL.
            // Global filters are applied to all metrics, per-metric filters only to their specific metric.
            //
            const chart = Chart.create();

            // Collect metrics and other filters
            let metrics = [];
            const otherFilters = {};

            if (filters) {
                Object.keys(filters).forEach(function (key) {
                    if (key === 'sf_metric') {
                        // Handle both single metric and array of metrics
                        if (angular.isArray(filters[key])) {
                            metrics = filters[key];
                        } else {
                            metrics = [filters[key]];
                        }
                    } else {
                        otherFilters[key] = filters[key];
                    }
                });
            }

            // If no metrics specified, create one empty plot
            if (metrics.length === 0) {
                metrics = [''];
            }

            // Create a plot for each metric
            metrics.forEach(function (metric, index) {
                const plot = chart.plot().metric(metric);

                // Apply global filters to each plot
                Object.keys(otherFilters).forEach(function (key) {
                    plot.propertyFilter(key, otherFilters[key]);
                });

                // Apply per-metric filters if they exist for this metric index
                if (perMetricFilters && perMetricFilters[index]) {
                    Object.keys(perMetricFilters[index]).forEach(function (key) {
                        plot.propertyFilter(key, perMetricFilters[index][key]);
                    });
                }
            });

            // Set chart name based on metrics
            if (metrics.length === 1 && metrics[0]) {
                chart.name(metrics[0]);
            } else if (metrics.length > 1) {
                chart.name(metrics.join(', '));
            }

            return chart;
        });
    },
]);
